export default "__VITE_ASSET__5fd91f59__"